const visibilityFilter = (state = 'SHOW_ALL', action = { type: null }) => {
  switch (action.type) {
    case 'SET_VISIBILITY_FILTER':
      return action.filter;
    default:
      return state;
  }
};

export default visibilityFilter;
